import { render, staticRenderFns } from "./wsEditorRegular.vue?vue&type=template&id=f1a65560&scoped=true&"
import script from "./wsEditorRegular.vue?vue&type=script&lang=js&"
export * from "./wsEditorRegular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a65560",
  null
  
)

export default component.exports